import _ from 'lodash';
import cogoToast from 'cogo-toast';
import moment from 'moment';

import * as ActionTypes from '../actions/DealsActions';

export const deals = (
  state = {
    allDeals: [],
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.GET_ALL_DEALS_SUCCESS:
      return {
        ...state,
        allDeals: _.orderBy(
          action.deals.map((deal) => {
            const calls = _.orderBy(deal.chats || deal.calls, 'created_at');
            return {
              ...deal,
              calls,
              recent_chat: calls[0],
              close_probability: _.min([deal.close_probability, 1]),
              calculated_close_probability: _.min([
                deal.close_probability === 1 ? 1 : deal.calculated_close_probability || deal.close_probability,
                1,
              ]),
              is_closed: deal.close_probability === 1,
            };
          }),
          [
            (d) => {
              const day = moment(d.close_date).format('YYYY-MM-DD');
              return new Date(day).getTime();
            },
            (d) => d.name.toLowerCase(),
          ]
        ),
      };

    case ActionTypes.ADD_DEAL_SUCCESS:
      return {
        ...state,
        allDeals: _.orderBy(
          [
            ...state.allDeals,
            {
              ...action.deal,
              recent_chat: action.deal.chats?.[0],
              close_probability: _.min([action.deal.close_probability, 1]),
              calculated_close_probability: _.min([
                action.deal.close_probability === 1 ? 1 : action.deal.calculated_close_probability || action.deal.close_probability,
                1,
              ]),
              is_closed: action.deal.close_probability === 1,
            },
          ],
          [
            (d) => {
              const day = moment(d.close_date).format('YYYY-MM-DD');
              return new Date(day).getTime();
            },
            // (d) => d.name.toLowerCase(), // Keep in place by not sorting on name
          ]
        ),
      };

    case ActionTypes.ADD_DEAL_FAILURE:
      cogoToast.error(`There was an error adding this deal, please try again.`);
      return {
        ...state,
      };

    case ActionTypes.UPDATE_DEAL_REQUEST:
      return {
        ...state,
        allDeals: state.allDeals.map((deal) =>
          action.deal.id === deal.id || action.deal.id === deal.id
            ? {
                ...deal,
                ...action.updates,
              }
            : deal
        ),
      };

    case ActionTypes.UPDATE_DEAL_FAILURE:
      cogoToast.error(`There was an error updating this deal.`);
      return {
        ...state,
      };

    case ActionTypes.DELETE_DEAL_REQUEST:
      return {
        ...state,
        allDeals: state.allDeals.filter((deal) => deal.id !== action.deal.id || deal.id !== action.deal.id),
      };

    case ActionTypes.DELETE_DEAL_FAILURE:
      cogoToast.error(`There was an issue deleting this deal, please try again.`);
      return {
        ...state,
        allDeals: _.orderBy(
          [...state.allDeals, action.deal],
          [
            (d) => {
              const day = moment(d.close_date).format('YYYY-MM-DD');
              return new Date(day).getTime();
            },
            (d) => d.name.toLowerCase(),
          ]
        ),
      };

    default:
      return state;
  }
};
